import type { LeadFlowStepEntryInput } from "./types";

import { getLeadFlowStepEntryMissingFieldNames } from "./get-lead-flow-step-entry-missing-field-names";

/**
 * Whether a visitor may start a lead flow at `stepIndex` (for example from a
 * step URL) instead of being sent back to the first step. Studio and the
 * runtime share this rule so a step Studio marks as enterable is one the
 * runtime will let a visitor land on.
 */
function isLeadFlowStepDirectlyEnterable(
  input: LeadFlowStepEntryInput,
): boolean {
  return getLeadFlowStepEntryMissingFieldNames(input).length === 0;
}

export { isLeadFlowStepDirectlyEnterable };
